module.exports = __webpack_public_path__ + "static/media/login.0f0d2476.png";